import { Outlet, Navigate } from 'react-router-dom'

import { useAccount, useAuth } from 'src/hooks'
import { ROUTES } from 'src/constants'
import { joinAbsRoute } from 'src/common/utils'
import { EAccountRoles } from 'src/types'

interface IAccountRolesRoute {
  roles: EAccountRoles[]
}

const AccountRolesRoute = ({ roles }: IAccountRolesRoute) => {
  const { data: account, isLoading } = useAccount()
  const { isSuperadmin } = useAuth()

  if (!isLoading && !account?.currentRoles?.some((role) => roles.includes(role))) {
    return <Navigate to={joinAbsRoute(ROUTES.ACCOUNTS)} replace />
  }

  if (!isLoading && account?.suspended && !isSuperadmin) {
    return (
      <Navigate to={joinAbsRoute(ROUTES.ACCOUNTS, account.id, ROUTES.ACCOUNT_SUSPENDED)} replace />
    )
  }

  return <Outlet />
}

export default AccountRolesRoute
